export const EDUCATION_MATERIAL_TYPES = 'education_Material_Types';
export const CONTENT_CATEGORIES = 'education_Content_Categories';
export const PATIENT_SEARCH_EXCLUSION_LIST_BOOLEAN = 'patientsearch_exclusion_list_boolean';
export const CARE_PLAN_ACTIVITY_COUNT = 'care_plan_activity_count';
export const SUPPORT_LINK_RESOURCES = 'support_link_resources';
export const ACTIVE_DASHBOARD_SHOW_ALL_ASSIGNED = 'active_dashboard_show_all_assigned';
export const SUPPORT_LINK_INFORMATION = 'support_link_information';
export const CLAIM_STATUS = 'claim_status';
export const RISK_STRATIFICATION_ALGORITHMS = 'risk_stratification_algorithms';
export const MEMBER_STATUS_COLOR = 'member_status_color';
export const IS_MEMBER_STATUS_CONFIGURABLE = 'new_patient_dashboard_use_column';
export const MEMBER_RISK_COLOR = 'member_risk_color';
export const DISPLAY_MEMBERMASTERSTATUS = 'display_memberMasterStatus';
export const ASSOCIATED_PATIENTS_EXCLUSION_LIST_BOOLEAN = 'associated_patients_exclusion_list_boolean';
export const PATIENT_SEARCH_EXPORT_COLUMNS = 'patient_search_export_columns';
export const NOTES_DISPLAY_LENGTH = 'notes_display_length';
export const CENSUS_DASHBOARD_IGNORE_STATUSES = 'census_dashboard_ignore_statuses';
export const FOLLOW_UP_CONFIG = 'member_admission_followup_config';
export const CARE_PLAN_OPEN_GOAL_CONFIG = 'care_plan_open_goal_config';
export const MEMBER_PROGRAMS_COLOR = 'member_programs_color';
export const CARE_PLAN_DISEASE_LIST = 'careplan_disease_list';
export const EXTERNAL_NAV_URLS = 'externalNavUrls';
export const USER_REGISTRATION_FORM_FIELDS = 'user_registration_form_fields';
export const SUPPORT_LINK_PUBLIC = 'support_link_public';
export const WSHEC_MEMBER_ZIPS = 'wshec_member_zips';
export const CRA_FORM_CONFIG = 'cra_form_config';
export const CARE_PLAN_CHECKBOXES_CONFIG = 'care_plan_checkbox_config';
export const DM_DASHBOARD_FILTERS = 'dm_dashboard_filters';
export const CENSUS_DASHBOARD_FILTERS = 'census_dashboard_filters';
export const SHOW_NETWORK_START_DATE = 'show_network_start_date';
export const WORKLIST_SRCTYPE_FILTER_CONFIG = 'worklist_srctype_filter_config';
export const SHOW_PAC_CARE_COORDINATOR = 'show_pac_care_coordinator';
export const SEND_MESSAGE_HELP_TEXT = 'send_message_help_text';
export const CENSUS_DASHBOARD_TYPE = 'census_dboard_type';
export const SHOW_RENEWAL_FORM = 'show_renewal_form';
export const MEMBER_ID_LABEL = 'member_id_label';
export const NETWORK_START_DATE_LABEL = 'network_start_date_label';
export const ENABLE_PAC_AUTHS = 'enable_pac_auths';
export const BASEBALL_CARD_VERSION = 'baseball-card-version';
export const SHOW_UNALIGNED_PATIENT_ALERT = 'show_unaligned_patient_alert';
export const ENABLE_PRIORITY_LEVEL = 'enable_priority_level';
export const HOSPITAL_ACTIVITY_VISIT_TYPES = 'hospital_activity_visit_types';
export const CM_OR_CC_MEMBER_TYPE = 'cm_or_cc_member_type';
export const SHOW_CURRENT_RISK = 'show_current_risk';
export const SHOW_CM_STATUS = 'show_cm_status';
export const SHOW_CM_STATUS_REASON = 'show_cm_status_reason';
export const SHOW_CARE_MANAGER = 'show_care_manager';
export const SHOW_HOURS_OF_OPERATION = 'show_hours_of_operation';
export const SHOW_REDE_DATE = 'show_rede_date';
export const OWNER_TYPE = 'owner_type';
export const ENABLE_OTHER_TEXT_TASK_TYPE = 'enable_other_text_task_type';
export const BBC_CC_CM_INFO_TYPE = 'bbc_cc_cm_info_type';
export const GLOBAL_STATUS_UPDATE_CONFIG = 'global_status_update_config';
export const SHOW_REFERRING_TO_SELECTION_DROPDOWN = 'show_referring_to_selection_dropdown';
export const SHOW_MEDICAL_HOME = 'show_medical_home';
export const SHOW_DUAL_STATUS = 'show_dual_status';
export const SHOW_AWV_SCHEDULED_DATE = 'show_awv_scheduled_date';
export const ASYNC_MEMBER_CREATION = 'async_member_creation';
export const PERMISSION_TYPE_DETAILS = 'permission_type_details';
export const SHOW_RISK = 'show_risk';
export const SUPPORT_TICKET_SUBJECTS = 'support_ticket_subjects';
export const SHOW_TERMDATE = 'show_termdate';
export const SHOW_EFFECTIVE_DATE = 'show_effective_date';
export const SHOW_PRODUCT = 'show_product';
export const MEMBER_SNAPSHOT_STATUS_ITEMS = 'member_snapshot_status_items';
export const MEMBER_SNAPSHOT_CM_ACTIVITIES_MAPPING_CONFIG = 'member_snapshot_cm_activities_mapping_config';
export const MEMBER_SNAPSHOT_UTILIZATION_AND_CHRONIC_CONDITIONS_MAPPING_CONFIG =
  'utilization_chronic_conditions_mapping_config';
export const SHOW_CME = 'show_cme';
export const SHOW_PLAN_NAME = 'show_plan_name';
export const SHOW_SITE_FIELD = 'show_site_field';
